




import { Component, Vue } from "vue-property-decorator";
import ContingentBox from "@/components/contingent/ContingentBox.vue";
import GlobalFilterSensitiveMixin from "@/mixins/GlobalFilterSensitiveMixin";
import { Action, Getter } from "vuex-class";
import { NavigationGuardNext, Route } from "vue-router";

@Component({
  components: { ContingentBox },
  mixins: [GlobalFilterSensitiveMixin],
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    const self = this as any;
    self.setCustomBreadcrumbs(undefined);
    next();
  }
})
export default class Contingent extends Vue {
  breadcrumbs: string[] = [];

  @Action("setCustomBreadcrumbs") setCustomBreadcrumbs?: (
    payload: string[] | undefined
  ) => Promise<void>;
  @Getter("customBreadcrumbs") customBreadcrumbs?: string[];
}
